module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jeannine Surette Honstein dedicates this book:")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To my father, William Federhen Surette, and his “Aunty” Lizzy Federhen.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To my mother, Margaret S. Surette, for the inspiration to do family research.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("With love to my husband, Robert.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("For our grandchildren Hazel, Henry, Judy and Teddy.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/ded.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Steven A. Knowlton dedicates this book:")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("To the memory of those who fought and died for liberty and union—now and forever, one and inseparable—that remembrance of their devotion to the last best hope of earth may strengthen our own resolve to preserve democracy in the present age.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e12992","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedication.vue
// module id = 63
// module chunks = 0